module.exports = __webpack_public_path__ + "img/rosalina-and-luma-min.88625c5f.png";